import type { NavItem } from "@/types";

/**
 * 헤더 관련 설정 상수
 *
 * 웹사이트 헤더의 동작과 스타일을 제어하는 설정값들을 정의합니다.
 * 스크롤 임계값, 애니메이션 지속시간, 스타일 속성 등을 포함합니다.
 */
export const HEADER_CONSTANTS = {
  /** 헤더 스타일 변경을 위한 스크롤 임계값 (픽셀) */
  SCROLL_THRESHOLD: 50,
  /** 모바일 메뉴 전환을 위한 브레이크포인트 (픽셀) */
  MOBILE_BREAKPOINT: 1024,
  /** 각종 애니메이션의 지속시간 (밀리초) */
  ANIMATION_DURATION: {
    HEADER: 200, // 헤더 전체 애니메이션
    MENU: 200, // 메뉴 열기/닫기
    DROPDOWN: 200, // 드롭다운 메뉴
    TEXT_COLOR: 100, // 텍스트 색상 변경
  },
  /** 메뉴 관련 크기 설정 */
  MENU: {
    MAX_HEIGHT: 500, // 최대 메뉴 높이
    MOBILE_FULL_HEIGHT: "h-screen", // 모바일 전체 화면 높이
  },
  /** 헤더 스타일 관련 설정 */
  STYLES: {
    LOGO_WIDTH: 160, // 로고 너비
    BORDER_COLORS: {
      // 테두리 색상 옵션
      LIGHT: "border-border", // 밝은 테마
      DARK: "border-white/20", // 어두운 테마
      DEFAULT: "border-border", // 기본 테마
    },
    TEXT_COLORS: {
      // 텍스트 색상 옵션
      PRIMARY: "text-primary", // 주요 색상
      FOREGROUND: "text-foreground", // 전경 색상
      WHITE: "text-white", // 흰색
      BLUE_HOVER: "text-blue-200", // 호버 시 파란색
    },
  },
};

/**
 * 네비게이션 메뉴 항목 상수
 *
 * 웹사이트 헤더의 메인 네비게이션 메뉴 구조를 정의합니다.
 * 각 메뉴 항목은 라벨, 링크, 서브메뉴를 포함하며,
 * 사용자가 웹사이트의 주요 섹션에 쉽게 접근할 수 있도록 합니다.
 *
 * 메뉴 구조:
 * - RISE사업단소개: 사업단 소개 및 정보
 * - RISE세부사업: 세부 사업 소개 및 프로그램
 * - 게시판: 공지사항, 채용정보, RISE사업공고
 * - 뉴스레터: 정기 뉴스 및 소식
 * - 자료실: 자료 다운로드 및 공유
 */
export const NAV_ITEMS: NavItem[] = [
  {
    label: "RISE사업단소개",
    href: "/greeting",
    submenu: [
      { label: "인사말", href: "/greeting" },
      { label: "조직도", href: "/organization" },
      { label: "오시는길", href: "/location" },
    ],
  },
  {
    label: "RISE추진사업",
    href: "/rise-business",
    submenu: [{ label: "RISE추진사업", href: "/rise-business" }],
  },
  {
    label: "알림마당",
    href: "/notices",
    submenu: [
      { label: "공지사항", href: "/notices" },
      { label: "채용공고", href: "/recruit" },
      { label: "사업공고", href: "/announcements" },
    ],
  },
  {
    label: "홍보",
    href: "/newsletters",
    submenu: [{ label: "뉴스레터", href: "/newsletters" }],
  },
  {
    label: "자료실",
    href: "/resources",
    submenu: [{ label: "자료실", href: "/resources" }],
  },
];
